var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 22.5H7.5V5H25V2.5H7.5C6.125 2.5 5 3.625 5 5V22.5ZM26.6251 10.75L34.2501 18.375C34.7501 18.875 35.0001 19.5 35.0001 20.125V35C35.0001 36.375 33.8751 37.5 32.5001 37.5H15.0001C13.6251 37.5 12.5001 36.375 12.5001 35V12.5C12.5001 11.125 13.6251 10 15.0001 10H25.0001C25.6251 10 26.2501 10.25 26.6251 10.75ZM32.3751 20L25.0001 12.5V20H32.3751ZM15.0001 12.5V35H32.5001V22.5H25.0001C23.6251 22.5 22.5001 21.375 22.5001 20V12.5H15.0001Z",
    fill: "#13BD7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b3f87c6ca3eb5014ae21ea46abba7de0.svg";
export { ForwardRef as ReactComponent };